import { common, InputModel } from '@neo-one/client-common';
export const input = (inputLike) => new InputModel({
    hash: common.stringToUInt256(inputLike.hash),
    index: inputLike.index,
});

//# sourceMappingURL=input.js.map
